import { render, staticRenderFns } from "./ShoulderRaising.vue?vue&type=template&id=269bbd5a"
import script from "./ShoulderRaising.vue?vue&type=script&lang=js"
export * from "./ShoulderRaising.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports